import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as cr from './_cr';

import { a } from './_csAbt';
import * as ls from './_csLcl';

import { useLdrz } from './_csLdr';
import { useMsgz } from './_csMdlMsg';

import * as BtnC from './_cccBtnC';
import * as GridC from './_cccGridC';
import * as IptC from './_ccbIptC';
import * as LblC from './_cccLblC';

let $dldz = {} as ht.dz;
let $cdnz = {} as ht.dz;

const $years = hf.getRng(20).map((_idx: ht.n) => {
  const _year = 2022 + _idx;
  return { key: _year, pfx: _year + '年' };
});

const $mths = hf.getRng(12).map((_idx: ht.n) => {
  const _mth = _idx;
  return { key: _mth, pfx: _mth + '月' };
});

export const N = (pz: {
  cz: {
    dlds: {
      pfx: ht.s,
      bYearMth?: ht.b,
      dldAsync: (_cdnz: ht.dz) => void,
    }[],
    clr?: ht.s,
  }
}) => {

  const _udtThis = ls.udtThis();

  const _sMsgz = useMsgz();
  const _sLdrz = useLdrz();

  const _sc = pz.cz.clr ?? 'lt';

  const _pcrs = hf.nn(pz.cz.dlds).map((_dz, _idx) => ({
    ... _dz,
    key: _idx,
    pfx: _dz.pfx,
  }));

  return (
    cr.c(GridC.N, {
      key: -10,
      abtType: 'nolineCmnz',
      lineCs: [
        {
          boxStlz: a('fd/css'),
          cellCs: [
            {
              boxStlz: a('dw/f mb/2'),
              oClds: [
                cr.c(LblC.N, {
                  key: -10,
                  abtType: '_vclz',
                  lblCz: {
                    textz: {
                      pfx: '出力データ：',
                      stlz: a(`tc/${_sc}7`),
                    }
                  },
                  cttCz: {
                    oClds: [
                      cr.c(IptC.S, {
                        key: -10,
                        iptStlz: a(`ta/c`),
                        cz: {
                          bEdit: true,
                          iptType: 'pcr',
                          ls: _pcrs,
                          vle: $dldz.key,
                          onChg: (_dz: ht.dz) => {
                            $dldz = _dz;
                            $cdnz = {} as ht.dz;
                            _udtThis();
                          }
                        }
                      })
                    ]
                  }
                })
              ],
            },
            $dldz.bYearMth ?
            {
              boxStlz: a('dw/f mb/4'),
              oClds: 
                [
                  cr.c(LblC.N, {
                    key: -10,
                    abtType: '_vclz',
                    lblCz: {
                      textz: {
                        pfx: '対象年月：',
                        stlz: a(`tc/${_sc}7`),
                      }
                    },
                    cttCz: {
                      boxStlz: a('dw/f f/n'),
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,                                
                          iptStlz: a(`ta/c`),
                          cz: {
                            bEdit: true,
                            iptType: 'pcr',
                            ls: $years,
                            vle: $cdnz.year,
                            onChg: (_dz: ht.dz) => {
                              $cdnz.year = _dz.key;
                              _udtThis();
                            }
                          }
                        }),
                        cr.c(IptC.S, {
                          key: -20,                                
                          iptStlz: a(`ta/c`),
                          cz: {
                            bEdit: true,
                            iptType: 'pcr',
                            ls: $mths,
                            vle: $cdnz.mth,
                            onChg: (_dz: ht.dz) => {
                              $cdnz.mth = _dz.key;
                              _udtThis();
                            }
                          }
                        })
                      ]
                    }
                  })
                ]
            }
            : undefined,
            {
              boxStlz: a(`dw/f fd/ccc mb/2`),
              oClds: [
                cr.c(BtnC.N, {
                  key: -10,
                  abtType: '_ctdz',
                  boxStlz: 
                      a(`dw/38 sc/${_sc}7`),
                  lblCz: {
                    textz: {
                      pfx: 'ダウンロード'
                    },
                  },
                  pslPtyz: {
                    onPress:
                    async () => {
                      _sLdrz.show();
                      const _b = await hf.ectSrlAsync([
                        async () => {
                          let _b = true;
                          if (!hf.f($dldz)) {
                            _b = false;
                            _sMsgz.show({
                              textCz: {
                                textz: {
                                  pfx: '出力データを選択ください',
                                }
                              }
                            })
                          }
                          return _b;
                        },
                        async () => {
                          let _b = true;
                          if (
                            $dldz.bYearMth && 
                            !($cdnz.year > 0 && $cdnz.mth > 0)
                          ) {
                            _b = false;
                            _sMsgz.show({
                              textCz: {
                                textz: {
                                  pfx: '対象年月を選択ください',
                                }
                              }
                            })
                          }
                          return _b;
                        }
                      ])
                      if ($dldz.dldAsync && _b) {
                        await $dldz.dldAsync($cdnz);
                      }
                      _sLdrz.hide();
                    }
                  },
                })
              ],
            }
          ],
        },
      ]
    })
  )
}
